import { frontendURL } from 'dashboard/helper/URLHelper.js';

import CampaignsPageRouteView from './pages/CampaignsPageRouteView.vue';
import LiveChatCampaignsPage from './pages/LiveChatCampaignsPage.vue';
import SMSCampaignsPage from './pages/SMSCampaignsPage.vue';
import WhatsAppCampaignsPage from './pages/WhatsAppCampaignsPage.vue';
import { FEATURE_FLAGS } from 'dashboard/featureFlags';
import { SIDEBAR_HIDDEN_CAMPAIGNS_BY_ACCOUNT } from 'dashboard/constants/accountSidebarOverrides';

const meta = {
  featureFlag: FEATURE_FLAGS.CAMPAIGNS,
  permissions: ['administrator'],
};

const whatsappOnlyCampaignsAccount = accountId => {
  const hidden = SIDEBAR_HIDDEN_CAMPAIGNS_BY_ACCOUNT[Number(accountId)] || [];
  return hidden.includes('Live chat') && hidden.includes('SMS');
};

const redirectAwayFromHiddenCampaigns = to => {
  if (!whatsappOnlyCampaignsAccount(to.params.accountId)) return true;
  return {
    name: 'campaigns_whatsapp_index',
    params: to.params,
    replace: true,
  };
};

const campaignsRoutes = {
  routes: [
    {
      path: frontendURL('accounts/:accountId/campaigns'),
      component: CampaignsPageRouteView,
      children: [
        {
          path: '',
          redirect: to => {
            if (whatsappOnlyCampaignsAccount(to.params.accountId)) {
              return { name: 'campaigns_whatsapp_index', params: to.params };
            }
            return { name: 'campaigns_ongoing_index', params: to.params };
          },
        },
        {
          path: 'ongoing',
          name: 'campaigns_ongoing_index',
          meta,
          redirect: to => {
            if (whatsappOnlyCampaignsAccount(to.params.accountId)) {
              return { name: 'campaigns_whatsapp_index', params: to.params };
            }
            return { name: 'campaigns_livechat_index', params: to.params };
          },
        },
        {
          path: 'one_off',
          name: 'campaigns_one_off_index',
          meta,
          redirect: to => {
            if (whatsappOnlyCampaignsAccount(to.params.accountId)) {
              return { name: 'campaigns_whatsapp_index', params: to.params };
            }
            return { name: 'campaigns_sms_index', params: to.params };
          },
        },
        {
          path: 'live_chat',
          name: 'campaigns_livechat_index',
          meta,
          beforeEnter: redirectAwayFromHiddenCampaigns,
          component: LiveChatCampaignsPage,
        },
        {
          path: 'sms',
          name: 'campaigns_sms_index',
          meta,
          beforeEnter: redirectAwayFromHiddenCampaigns,
          component: SMSCampaignsPage,
        },
        {
          path: 'whatsapp',
          name: 'campaigns_whatsapp_index',
          meta: {
            ...meta,
            featureFlag: FEATURE_FLAGS.WHATSAPP_CAMPAIGNS,
          },
          component: WhatsAppCampaignsPage,
        },
      ],
    },
  ],
};

export default campaignsRoutes;
